import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { DocCareMockup } from "./DocCareMockup";

const DELIVERABLES = [
  "Business Requirements",
  "Product Requirements",
  "User Stories",
  "Business Rules",
  "Product Backlog",
  "UAT Scenarios",
  "Working Application Demo",
];

const CAPABILITIES = [
  "Doctor Search",
  "Doctor Profiles",
  "Availability",
  "Appointment Booking",
  "Appointment Management",
  "Reschedule / Cancel",
  "Notifications",
];

export default function DocCare() {
  return (
    <section
      id="doccare"
      data-testid="doccare-section"
      className="scroll-mt-24 bg-navy py-24 text-cream md:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-6 md:grid-cols-12 md:px-12">
        <div className="md:col-span-6">
          <Reveal>
            <Eyebrow dark>Featured Project — Healthcare Product Case Study</Eyebrow>
            <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.15] tracking-tight md:text-5xl">
              DocCare — healthcare appointments, made simple.
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-cream/70">
              A healthcare appointment-booking product concept designed from
              business requirements through product definition and a working
              application.
            </p>
            <p className="mt-4 text-sm text-cream/55">
              Role: Business Analyst | Product Consultant
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8">
              <p className="text-xs font-medium uppercase tracking-[0.2em] text-sage">
                Deliverables
              </p>
              <ul className="mt-4 flex flex-wrap gap-2">
                {DELIVERABLES.map((d) => (
                  <li
                    key={d}
                    className="rounded-full border border-cream/20 px-3.5 py-1.5 text-xs text-cream/80"
                  >
                    {d}
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-7">
              <p className="text-xs font-medium uppercase tracking-[0.2em] text-sage">
                Key capabilities
              </p>
              <ul className="mt-4 flex flex-wrap gap-2">
                {CAPABILITIES.map((c) => (
                  <li
                    key={c}
                    className="flex items-center gap-2 rounded-full bg-cream/5 px-3.5 py-1.5 text-xs text-cream/80"
                  >
                    <span className="h-1 w-1 rounded-full bg-rust" />
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-wrap items-center gap-6">
              <Link
                to="/doccare"
                data-testid="doccare-case-study-btn"
                className="group inline-flex items-center gap-2 rounded-full bg-rust px-7 py-3.5 text-sm font-medium text-white transition-transform duration-300 hover:-translate-y-0.5"
              >
                View DocCare Case Study
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
              </Link>
              <p className="text-xs italic text-cream/45">
                A portfolio product concept — designed and built as a case
                study, not for a client.
              </p>
            </div>
          </Reveal>
        </div>
        <div className="md:col-span-6">
          <Reveal delay={0.15}>
            <div className="relative">
              <div
                className="absolute -left-4 -top-4 h-full w-full rounded-xl border border-cream/10"
                aria-hidden="true"
              />
              <DocCareMockup />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
